/**
 * Nosto Validation Helper
 * 
 * Script de ayuda para validar que el tracking de impresiones de Nosto
 * está funcionando correctamente.
 * 
 * Uso:
 * 1. Abre la consola del navegador (F12)
 * 2. Ejecuta: NostoValidator.run()
 */

// Asegurar que el script se ejecute incluso si se carga después
(function() {
  'use strict';
  
  // Verificar si ya existe (evitar duplicados)
  if (window.NostoValidator) {
    console.log('[Nosto Validator] Ya está cargado');
    return;
  }

  const Validator = {
    results: [],
    
    /**
     * Ejecuta todas las validaciones
     */
    run: function() {
      console.log('%c🔍 Iniciando validación de Nosto Tracking...', 'color: #4CAF50; font-weight: bold; font-size: 14px;');
      this.results = [];
      
      this.validateScriptLoaded();
      this.validateNostoElements();
      this.validateTrackingState();
      this.validateImpressions();
      this.validateClicks();
      this.showSummary();
    },
    
    /**
     * Valida que el script de tracking esté cargado
     */
    validateScriptLoaded: function() {
      const result = {
        name: 'Script de Tracking Cargado',
        passed: typeof window.NostoTrackingDebug !== 'undefined',
        message: ''
      };
      
      if (result.passed) {
        result.message = '✅ El script de tracking está cargado correctamente';
      } else {
        result.message = '❌ El script de tracking NO está cargado. Verifica que nosto-impression-tracking.js se esté cargando.';
      }
      
      this.results.push(result);
      console.log(result.message);
    },
    
    /**
     * Valida que existan elementos de Nosto en la página
     */
    validateNostoElements: function() {
      const elements = document.querySelectorAll('.nosto_element[id], [data-nosto-placement]');
      const result = {
        name: 'Elementos de Nosto Encontrados',
        passed: elements.length > 0,
        message: '',
        details: {
          count: elements.length,
          elements: Array.from(elements).map(el => ({
            id: el.id || el.getAttribute('data-nosto-placement'),
            visible: this.isVisible(el),
            hasContent: el.children.length > 0 || el.innerHTML.trim().length > 0
          }))
        }
      };
      
      if (result.passed) {
        result.message = `✅ Se encontraron ${elements.length} elemento(s) de Nosto`;
      } else {
        result.message = '❌ No se encontraron elementos de Nosto en la página';
      }
      
      this.results.push(result);
      console.log(result.message);
      if (result.details.elements.length > 0) {
        console.table(result.details.elements);
      }
    },
    
    /**
     * Valida el estado del tracking
     */
    validateTrackingState: function() {
      if (typeof window.NostoTrackingDebug === 'undefined') {
        return;
      }
      
      const state = window.NostoTrackingDebug.getState();
      const stats = window.NostoTrackingDebug.getStats();
      
      const result = {
        name: 'Estado del Tracking',
        passed: true,
        message: '✅ Estado del tracking disponible',
        details: {
          elementosObservados: stats.elementsObserved,
          impresionesRegistradas: stats.impressionsTracked,
          clicsAntesDeImpresion: stats.clicksBeforeImpression,
          modoDebug: state.debugMode
        }
      };
      
      if (stats.clicksBeforeImpression > 0) {
        result.passed = false;
        result.message = `⚠️ Se detectaron ${stats.clicksBeforeImpression} clic(s) antes de impresiones`;
      }
      
      this.results.push(result);
      console.log(result.message);
      console.table(result.details);
    },
    
    /**
     * Valida que las impresiones se estén registrando
     */
    validateImpressions: function() {
      if (typeof window.NostoTrackingDebug === 'undefined') {
        return;
      }
      
      const tracked = window.NostoTrackingDebug.getTrackedImpressions();
      const result = {
        name: 'Impresiones Registradas',
        passed: tracked.length > 0,
        message: '',
        details: {
          count: tracked.length,
          placements: tracked
        }
      };
      
      if (result.passed) {
        result.message = `✅ Se registraron ${tracked.length} impresión(es)`;
      } else {
        result.message = '⚠️ Aún no se han registrado impresiones. Esto puede ser normal si los elementos están fuera del viewport.';
      }
      
      this.results.push(result);
      console.log(result.message);
      if (tracked.length > 0) {
        console.log('Placements con impresiones:', tracked);
      }
    },
    
    /**
     * Valida el manejo de clics
     */
    validateClicks: function() {
      const result = {
        name: 'Manejo de Clics',
        passed: true,
        message: '✅ El sistema de detección de clics está activo',
        details: {}
      };
      
      // Verificar que el event listener esté activo
      // Esto es difícil de verificar directamente, así que solo confirmamos
      this.results.push(result);
      console.log(result.message);
    },
    
    /**
     * Verifica si un elemento es visible
     */
    isVisible: function(element) {
      if (!element) return false;
      const rect = element.getBoundingClientRect();
      const style = window.getComputedStyle(element);
      return (
        rect.width > 0 &&
        rect.height > 0 &&
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        style.opacity !== '0'
      );
    },
    
    /**
     * Muestra un resumen de todas las validaciones
     */
    showSummary: function() {
      const passed = this.results.filter(r => r.passed).length;
      const total = this.results.length;
      const allPassed = passed === total;
      
      console.log('\n%c' + '='.repeat(50), 'color: #2196F3; font-weight: bold;');
      console.log('%c📊 RESUMEN DE VALIDACIÓN', 'color: #2196F3; font-weight: bold; font-size: 16px;');
      console.log('%c' + '='.repeat(50), 'color: #2196F3; font-weight: bold;');
      
      this.results.forEach(result => {
        const icon = result.passed ? '✅' : '❌';
        const color = result.passed ? '#4CAF50' : '#F44336';
        console.log(`%c${icon} ${result.name}`, `color: ${color}; font-weight: bold;`);
        if (result.details && Object.keys(result.details).length > 0) {
          console.log('   Detalles:', result.details);
        }
      });
      
      console.log('\n%c' + '='.repeat(50), 'color: #2196F3; font-weight: bold;');
      if (allPassed) {
        console.log('%c✅ TODAS LAS VALIDACIONES PASARON', 'color: #4CAF50; font-weight: bold; font-size: 14px;');
      } else {
        console.log(`%c⚠️ ${passed}/${total} validaciones pasaron`, 'color: #FF9800; font-weight: bold; font-size: 14px;');
      }
      console.log('%c' + '='.repeat(50), 'color: #2196F3; font-weight: bold;');
      
      // Mostrar recomendaciones
      this.showRecommendations();
    },
    
    /**
     * Muestra recomendaciones basadas en los resultados
     */
    showRecommendations: function() {
      const recommendations = [];
      
      if (typeof window.NostoTrackingDebug === 'undefined') {
        recommendations.push('• Verifica que el script nosto-impression-tracking.js se esté cargando en el layout');
      }
      
      const elements = document.querySelectorAll('.nosto_element[id], [data-nosto-placement]');
      if (elements.length === 0) {
        recommendations.push('• No se encontraron elementos de Nosto. Verifica que las secciones de Nosto estén configuradas');
      }
      
      if (typeof window.NostoTrackingDebug !== 'undefined') {
        const stats = window.NostoTrackingDebug.getStats();
        if (stats.clicksBeforeImpression > 0) {
          recommendations.push(`• Se detectaron ${stats.clicksBeforeImpression} clic(s) antes de impresiones. Esto indica que el script está funcionando pero hay un problema de timing.`);
        }
        
        if (stats.impressionsTracked === 0 && elements.length > 0) {
          recommendations.push('• No se han registrado impresiones aún. Esto puede ser normal si:');
          recommendations.push('  - Los elementos están fuera del viewport');
          recommendations.push('  - Nosto aún no ha cargado su contenido');
          recommendations.push('  - Haz scroll hacia los elementos de Nosto y espera unos segundos');
        }
      }
      
      if (recommendations.length > 0) {
        console.log('\n%c💡 RECOMENDACIONES:', 'color: #FF9800; font-weight: bold;');
        recommendations.forEach(rec => {
          console.log(`%c${rec}`, 'color: #666;');
        });
      }
    },
    
    /**
     * Monitorea eventos de impresión en tiempo real
     */
    monitorImpressions: function() {
      console.log('%c👀 Monitoreando eventos de impresión...', 'color: #2196F3; font-weight: bold;');
      
      document.addEventListener('nosto:impression:tracked', function(event) {
        console.log('%c✅ Impresión registrada:', 'color: #4CAF50; font-weight: bold;', event.detail);
      });
      
      console.log('El monitoreo está activo. Haz scroll por la página para ver las impresiones.');
    },
    
    /**
     * Prueba manual de impresión
     */
    testImpression: function(placementId) {
      const element = document.querySelector(`#${placementId}, [data-nosto-placement="${placementId}"]`);
      if (!element) {
        console.error(`❌ No se encontró elemento con ID: ${placementId}`);
        return;
      }
      
      console.log(`🧪 Probando impresión para: ${placementId}`);
      
      // Simular que el elemento es visible y tiene contenido
      if (typeof window.NostoTrackingDebug !== 'undefined') {
        const state = window.NostoTrackingDebug.getState();
        if (state.impressionTracked.has(placementId)) {
          console.log('⚠️ Ya se registró una impresión para este elemento');
        } else {
          console.log('El elemento será observado automáticamente cuando sea visible');
        }
      }
    }
  };
  
  // Exponer globalmente - asegurar que esté disponible incluso si el script carga después
  window.NostoValidator = Validator;
  
  // También exponer después de que el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      window.NostoValidator = Validator;
    });
  }
  
  // Auto-ejecutar si está en modo debug
  if (window.location.search.includes('nosto-validate=true')) {
    setTimeout(() => {
      if (window.NostoValidator) {
        Validator.run();
      }
    }, 2000);
  }
  
  // Mensaje de confirmación solo si se solicita explícitamente (modo debug o parámetro URL)
  const showValidatorMessages = window.location.search.includes('nosto-validate=true') || 
                                window.location.search.includes('nosto-debug=true') ||
                                localStorage.getItem('nosto-tracking-debug') === 'true';
  
  if (showValidatorMessages) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        console.log('%c🔧 Nosto Validator cargado', 'color: #2196F3; font-weight: bold;');
        console.log('Ejecuta NostoValidator.run() para validar el tracking');
        console.log('Ejecuta NostoValidator.monitorImpressions() para monitorear eventos en tiempo real');
      });
    } else {
      console.log('%c🔧 Nosto Validator cargado', 'color: #2196F3; font-weight: bold;');
      console.log('Ejecuta NostoValidator.run() para validar el tracking');
      console.log('Ejecuta NostoValidator.monitorImpressions() para monitorear eventos en tiempo real');
    }
  }
})();
